import { useTranslation } from 'react-i18next'

import { useSessionEntity } from '@app/context/EntityContext'
import { RouteConfig } from '@app/routing/RenderRoutes'

import { Navigate } from '@lib/react-router-dom'

import { isTickmillSCType } from '@utils/companyName.utils'

import { CampaignsHistoryTab } from './CampaignsHistoryTab'
import { RewardsHistoryTab } from './RewardsHistoryTab'
import { RewardsHubPage } from './RewardsHub.page'

export const useRewardsHubRoutes = (): RouteConfig[] => {
  const { t } = useTranslation()
  const tickmillEntity = useSessionEntity()
  const isTickmillScEntity = isTickmillSCType(tickmillEntity)

  return [
    {
      path: 'rewards-hub',
      condition: isTickmillScEntity,
      outlet: <RewardsHubPage />,
      element: <Navigate to='rewards' replace />,
      meta: {
        breadcrumbLabel: t('RewardsHub.Rewards Hub'),
      },
      children: [
        {
          path: 'rewards',
          element: <RewardsHistoryTab />,
          meta: {
            breadcrumbLabel: t('RewardsHub.Rewards'),
          },
        },
        {
          path: 'campaigns',
          element: <CampaignsHistoryTab />,
          meta: {
            breadcrumbLabel: t('RewardsHub.Campaigns'),
          },
        },
      ],
    },
  ]
}
